import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ModalController } from "ionic-angular";
import { NavController } from "ionic-angular";
import { AlertController, NavParams } from "ionic-angular";
import { GuestAddPage } from "../../components/attendancecomponent/guest_add";
import { GuestUpdatePage } from "../../components/attendancecomponent/guest_update";
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { Attendance } from "../../models/interfaces/attendance.model";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Guest } from "../../models/interfaces/guest.model";
import { Member } from "../../models/interfaces/member.model";
import { HarelineViewPage } from "../../pages/hareline/hareline_view";
import { HomePage } from "../../pages/home/home";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "attendancecomponent",
  templateUrl: "attendancecomponent.html"
})


export class AttendanceComponent {
  public static readonly ATTD_UPD_ACCESS = "updateAttendance";
  @Input() hareline;
  @Output() newItemEvent = new EventEmitter<string>();
  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }


  private attendees: string[] = [];
  private currentUser: Member;

  private attendance: any;
  private enableAttendanceBtn: boolean = false;
  private guest: any;
  private LOAcnt: number;
  private LOAttl: number;
  private membercnt: number;
  private memberttl: number;
  private guestcnt: number;
  private guestttl: number;
  private attendance_confirmed: any;
  private attendance_confirmed_LOA: any;
  private attendance_confirmed_Regular: any;
  private attendanceTTL: number;
  private cnt: number;
  private distinct_status = [];
  private hl_id: number;
  private isAdded: boolean = false;
  private showAttendance: boolean = true;
  private showGuest: boolean = true;
  private styleName: string ="";


  private hasUpdAttendanceAccess: boolean = false;
  constructor(private configService: ConfigService,private authService: AuthService, public navParams: NavParams, public navCtrl: NavController,
    public alertCtrl: AlertController, private db: DbserviceProvider,
    public modalCtrl: ModalController) {
    console.log("AttendanceComponent constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    
    if (this.navParams.get("hareline") === undefined) {
      this.hl_id = 0;
    }
    else {
      this.hl_id = this.navParams.get("hareline")[0].hl_id;
      if ( this.navParams.get("hareline")[0].cp_name !== "Dog Hash") {
        this.enableAttendanceBtn = true;
      }
    }

    if (this.authService.currentUser) {
      this.hasUpdAttendanceAccess = this.db.hasAccess(AttendanceComponent.ATTD_UPD_ACCESS);
    }
    this.db.dbCol({
      "action": "select", "mapObject": "vw_attendance", "sqlExtended": " where  hl_id = '" +
        this.hl_id + "' order by mb_hashname"
    }).subscribe((lns) => {
      this.attendance = lns;
      this.attendanceTTL = lns.length;
      this.attendance_confirmed = lns.filter(data => data.at_confirmed_flg == 1).length;
      this.attendance_confirmed_LOA = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 1).length;
      this.attendance_confirmed_Regular = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 2).length;
      this.addNewItem("LOAcnt:" + this.attendance_confirmed_LOA);
      this.addNewItem("mbrcnt:" + this.attendance_confirmed_Regular);
    });
    this.db.dbCol({
      "action": "select", "mapObject": "vw_guest", "sqlExtended": " where  hl_id = '" +
        this.hl_id + "' order by gt_name asc",
    }).subscribe((gt) => {
      this.distinct_status = gt.reduce((prev, { st_id, st_name }) =>
      prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name }], [])
      this.distinct_status.push()

      this.guestttl = 0;
      gt.forEach((guest) => {
        this.guestttl += Number(guest.gt_amount);
      })
      this.addNewItem("guestttl:" + this.guestttl);
      this.guest = gt;
      this.guestcnt = gt.length;
      this.addNewItem("guestcnt:" + gt.length);
    });


  }

  private getMember(currst: number) {
    console.log("MemberPage viewMemberStatus");

    if (currst == 99) {
      return this.attendance;
    }
    else {
      return this.attendance.filter(data => Number(data.st_id) === Number(currst));
    }

  }

  ngOnChanges() {
    console.log("AttendanceComponent ngOnChanges");
    if (this.isAdded) {
      this.db.dbCol({
        "action": "select", "mapObject": "vw_guest", "sqlExtended": " where  hl_id = '" +
          this.hl_id + "' order by gt_name asc ",
      }).subscribe((gt) => {
        this.guestttl = 0;
        gt.forEach((guest) => {
          this.guestttl += Number(guest.gt_amount);
        })
        this.addNewItem("guestttl:" + this.guestttl);
        this.guest = gt;
        this.guestcnt = gt.length;
        this.addNewItem("guest:" + gt.length);
      });
      this.isAdded = false;
    }
  }


  private ionViewWillEnter() {
    console.log("AttendanceComponent ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("AttendanceComponent onInitPage");

  }

  private viewGuest(guest: Guest) {
    console.log("AttendanceComponent viewGuest");

    if (this.hasUpdAttendanceAccess) {
      this.isAdded = true;
      this.navCtrl.push(GuestUpdatePage, {
        "guest": guest,
      });
    }

  }


  private viewAttendance(attendance: Attendance) {
    console.log("AttendanceComponent viewAttendance");
  }
  private toggleAttendance() {
    console.log("AttendanceComponent toggleAttendance");
    this.showAttendance = !this.showAttendance;
  }
  private toggleGuest() {
    console.log("AttendanceComponent toggleGuest");
    this.showGuest = !this.showGuest;
  }

  private addAttendance(attendees: any) {
    console.log("AttendanceComponent addAttendance");
    this.cnt = 0;

    this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM attendance WHERE hl_id='" + this.hareline.hl_id + "'" })
      .subscribe((ret) => {
        attendees.forEach((el) => {
          this.db.dbCol({
            "action": "insert",
            "mapObject": "attendance",
            "at_confirmed_flg": "1",
            "hl_id": this.hareline.hl_id,
            "mb_id": el.mb_id,
          }).subscribe((ln) => {
            this.cnt = this.cnt + 1;
            if (this.cnt === attendees.length) {
              this.db.dbCol({
                "action": "select", "mapObject": "vw_attendance", "sqlExtended": " where hl_id = '" +
                  this.hareline.hl_id + "' order by mb_hashname",
              }).subscribe((lns) => {
                this.attendance = lns;
                this.attendanceTTL = lns.length;
                this.attendance_confirmed = lns.filter(data => data.at_confirmed_flg == 1).length;
                this.attendance_confirmed_LOA = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 1).length;
                this.attendance_confirmed_Regular = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 2).length;
                this.addNewItem("LOAcnt:" + this.attendance_confirmed_LOA);
                this.addNewItem("mbrcnt:" + this.attendance_confirmed_Regular);
              });
            }
          });
        });
      },
    );
  }

  private selectAttendanceList(val) {
    console.log("AttendanceComponent selectAttendanceList " + this.hareline.id);
    this.attendees = [];

    this.db.dbCol({
      "action": "select", "mapObject": "attendance", "sqlExtended": " where attendance.hl_id = '" +
        this.hareline.hl_id + "' order by at_confirmed_flg",
    }).take(1)
      .subscribe((val) => {
        val.map((dd) => {
          this.attendees.push(dd.mb_hashname);
        });

        let selection = this.modalCtrl.create(ListComponent,
          { "obs": "member", "sel": this.attendees.toString() });
        selection.present();
        selection.onDidDismiss((data) => {
          this.addAttendance(data);
        });
      },
    );
  }


  private AddGuest(id: string) {
    console.log("AttendanceComponent AddGuest");
    this.navCtrl.push(GuestAddPage, {
      "hareline": this.navParams.get("hareline")
    });
    this.isAdded = true;
    console.error("Haha");
  }

  private updateAttendance(at_id: string, at_confirmed_flg: string) {
    console.log("AttendanceComponent updateAttendance");
    const attendanceValues: any = {
      "at_confirmed_flg": (at_confirmed_flg === "1" ? "0" : "1")
    }

    this.db.dbCol({ "action": "update", "mapObject": "attendance", "at_id": at_id, ...attendanceValues })
      .subscribe((ret) => {
        this.db.dbCol({
          "action": "select", "mapObject": "vw_attendance", "sqlExtended": " where  hl_id = '" +
            this.hl_id + "' order by mb_hashname"
        }).subscribe((lns) => {
          this.attendance = lns;
          this.attendanceTTL = lns.length;
          this.attendance_confirmed = lns.filter(data => data.at_confirmed_flg == 1).length;
          this.attendance_confirmed_LOA = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 1).length;
          this.attendance_confirmed_Regular = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 2).length;
          this.addNewItem("LOAcnt:" + this.attendance_confirmed_LOA);
          this.addNewItem("mbrcnt:" + this.attendance_confirmed_Regular);
        });
      }
      );
  }

  private deleteAttendance(at_id: string) {
    console.log("AttendanceComponent deleteAttendance");
    this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM attendance WHERE at_id='" + at_id + "'" })
      .subscribe((ret) => {
        this.db.dbCol({
          "action": "select", "mapObject": "vw_attendance", "sqlExtended": " where hl_id = '" +
            this.hareline.hl_id + "' order by mb_hashname",
        }).subscribe((lns) => {
          this.attendance = lns;
          this.attendanceTTL = lns.length;
          this.attendance_confirmed = lns.filter(data => data.at_confirmed_flg == 1).length;
          this.attendance_confirmed_LOA = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 1).length;
          this.attendance_confirmed_Regular = lns.filter(data => data.at_confirmed_flg == 1 && data.st_id == 2).length;
          this.addNewItem("LOAcnt:" + this.attendance_confirmed_LOA);
          this.addNewItem("mbrcnt:" + this.attendance_confirmed_Regular);
        });
      },
    );
  }

  private showAddAttendance(title: string, message: string, id: string, attendanceValues: {}) {
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            /// this.db.update("attendance", id, attendanceValues);
          },
          "text": "Yes",
        },
        {
          "handler": () => { },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/attendancecomponent/attendancecomponent.ts